// extracted by mini-css-extract-plugin
export var Choices = "styles-module--Choices--kaxiU";
export var Choice_Input = "styles-module--Choice_Input--3Ww2j";
export var Choice_Label = "styles-module--Choice_Label--q5b-y";
export var Choice_Label_Checked = "styles-module--Choice_Label_Checked--2gnR8";